


import { useEffect, useState } from "react";
import OrderCardsComp from "./OrderCardsComp";
import { getDashboardDetailsApi } from "../../helper/apiHelper";
import { BaseUrl } from "../../helper/apiHelper";
import axios from "axios";
import toast from "react-hot-toast";
const DashboardComp = () => {

    const [isLoading, setIsLoading] = useState(false)






    const [dashboardDetails, setDashboardDetails] = useState([])
    const [supportData, setSupportData] = useState([])

    const getAdminDashboardDetails = async () => {
        try {
            setIsLoading(true)
            let response = await getDashboardDetailsApi()
            console.log("Response", response?.data);
            const dashData = response?.data
            setDashboardDetails(dashData)



        } catch (error) {
            toast.error(error?.message || "Something went wrong")
            console.log(error);

        }

        finally {
            setIsLoading(false)
        }
    }
    console.log("Dashboard Details ::", dashboardDetails);




    useEffect(() => {
        getAdminDashboardDetails()
    }, [])











    return (
        <div className='row gy-4'>
            <OrderCardsComp isLoading={isLoading} dashboardDetails={dashboardDetails} />




        </div>
    );
};

export default DashboardComp;
